import { WorkflowItemProps } from "apis";
import { lazy } from "react";

export const PageAdminWorkflow = lazy(() => import("./List"));
export const PageAdminWorkflowCreate = lazy(() => import("./Add"));
export const PageAdminWorkflowUpdate = lazy(() => import("./Edit"));
export * from "./step";

export interface FormWorkflowValuesProps extends WorkflowItemProps {
    // beginStatusId: number;
    statusIds: number[];
}